<template>
  <div>
    <!--    头部-->
    <NavTop class="navbar">
      <template v-slot:headerImgRight >
        <div class="img_top_text">学生服务</div>
      </template>
      <template v-slot:mainnavlist>
        <div class="nav" @click="navigateTo('/stuDetils')">中心概况</div>
        <div class="nav" @click="navigateTo('/stuDetils')">中心动态</div>
        <el-dropdown class="dropdown" >
          <span class="el-dropdown-link" >
            服务项目<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item ><div @click="navigateTo('/educational')" >办事窗口</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/educational')" >办事指南</div></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="dropdown" >
          <span class="el-dropdown-link" >
            解决方案<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item ><div @click="navigateTo('/stuDetils')" >学生组织</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >兵役咨询</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >学籍管理</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >学生资助</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >学生社团管理</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >继续教育</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >第二课堂</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >教务教学</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >学生团务</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >学生党务</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >就业创业中心</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >收费中心</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/stuDetils')" >学生权益中心</div></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="navigateTo('/stuDetils')">下载专区</div>
      </template>
    </NavTop>

    <DetailedPage
      :rightTitle="'人才培养方案'"
      :homeLink="{ to: '/', text: '首页' }"
      :workDynamicsLink="{ to: '/educational', text: '人才培养方案' }"
    >
      <!-- 使用 slot 添加自定义内容 -->
      <template v-slot:txt-content>
        <div class="part_title">
          {{title}}
        </div>
        <div class="author">作者： {{author}}&nbsp;| <div class="date">&nbsp;2023-10-18</div>
        </div>
        <div class="new_content">
          {{content}}
        </div>
      </template>
    </DetailedPage>
  </div>
</template>

<script>
import NavTop from '../../../components/comcomponents/NavTop.vue'

export default {
  components: {
    NavTop,
  },
  data() {
    return {
      title:'学校党委举办主题教育专家辅导报告会',
      author:'党委办公室',
      date:'2023-10-18',
      content:'10月18日下午，学校党委举办学习贯彻习近平新时代中国特色社会主义思想主题教育专家辅导报告会，学校党委书记刘文根及中层以上党员干部、全体教职工党员和思政课教师参加报告会，党委副书记潘冲主持会议。',
      newsList:[
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习（扩大）会议 集体学习《中共中央 国务院关于弘扬教育家精神 加强新时代',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
      ],

    };
  },
  methods:{
    navigateTo(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style>
.part_title{
  margin: 20px 0 10px 0;
  font-size: 22px;
  font-weight: bolder;
}
.author{
  display: flex;
  flex-direction: row;
  color: #666;
  font-size: 14px;
}
.news{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px ;
}
.new_content{
  margin: 20px 0;
  text-indent: 2em;
}
.news:hover{
  color: #9e070e;
}
</style>



// WEBPACK FOOTER //
// src/views/Student/Detils/index.vue